import * as Sentry from '@sentry/browser';

angular.module('exceptionOverride', []).factory('$exceptionHandler', ['$window', function ($window) {
  return function (exception, cause) {
    if ($window.Bugsnag) {
      Bugsnag.notify(exception, function (event) {
        event.addMetadata('angular', { cause: cause });
      });
    }
    // No DSN/no-init guard needed: Sentry.captureException is already a no-op
    // when no client has been initialized (see ui/src/main.ts).
    Sentry.captureException(exception, { extra: { cause: cause } });
  };
}]);
